import React from "react";
import {ErrorBoundary} from "../elements/ErrorBoundary";

export default (Component) => (props) =>
  (
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
  );
